import { UserManager } from "oidc-client"
import { IDENTITY_CONFIG } from "../config/Identity"


export default class AuthService {
  userManager: UserManager

  constructor() {
    this.userManager = new UserManager({
      ...IDENTITY_CONFIG
    })
    console.log(IDENTITY_CONFIG);
  }

  signinRedirectCallback = (url?: string) => {
    return this.userManager.signinRedirectCallback(url)
  }

  getUser = () => {
    return this.userManager.getUser()
  }

  signinRedirect = (provider?: string) => {
    if (provider && provider !== "") {
      return this.userManager.signinRedirect({
        // TODO: Uncomment this to provide IDP name to PingOne
        // extraQueryParams: {
        //   acr_values: `idp:${provider}`
        // }
      })
    } else {
      return this.userManager.signinRedirect()
    }
  }
}
